import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/components/images/bg-invite.png'
import _imports_1 from '@/components/images/coin.png'
import _imports_2 from '@/components/images/icon-wx.png'
import _imports_3 from '@/components/images/icon-qq.png'


const _hoisted_1 = {
  class: "InviteDialog",
  "data-test": "invite-dialog"
}
const _hoisted_2 = { class: "InviteDialog__container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<img class=\"bg\" src=\"" + _imports_0 + "\" alt=\"\"><div class=\"InviteDialog__header\"></div><img class=\"gif\" src=\"" + _imports_1 + "\"><p class=\"gif-name\">20KK币</p><p class=\"tip\">邀请1位好友与你组队，下周一即可领取</p>", 5)
const _hoisted_8 = { class: "InviteDialog_btns" }

import { useShare } from '@/hooks/useShare';
import { useLogin } from '@/hooks/uselogin';
import { useTrack } from '@/hooks/useTrack';

export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



const doShare = useShare();
const { clickLogin } = useLogin();
const { trackPopupBtn } = useTrack();

function onClose (btnName?: string) {
  if (typeof btnName === 'string') {
    trackPopupBtn('首访引导弹窗', '关闭');
  }
  emit('close');
}
function share (platform: 'Wechat' | 'QQ') {
  const trackMap = {
    Wechat: '邀请微信好友',
    QQ: '邀请QQ好友'
  };
  trackPopupBtn('首访引导弹窗', trackMap[platform]);
  if (clickLogin()) {
    doShare({
      title: '快看可以领币免费看漫画啦！快来跟我组队一起薅羊毛吧>V<',
      desc: '快看APP真的有超多好看的漫画，快来一起看呀~~',
      shareImage: `${process.env.VUE_APP_SHARE_IMAGE}`,
      platform
    });
    onClose();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "InviteDialog__close",
        "data-test": "close-btn",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onClose('关闭')), ["stop"]))
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("img", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (share('Wechat'))),
        src: _imports_2
      }),
      _createElementVNode("img", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (share('QQ'))),
        src: _imports_3
      })
    ])
  ]))
}
}

})